export function manageAppVersion(APP_VERSION, options = {}) {
    const {
        cookiesToPreserve = [],
        localStorageToClear = [],
        shouldReload = true
    } = options;


    const defaultAuthCookies = [
        'auth_token',
        'refresh_token',
        'session_id',
        'user_session',
        'access_token',

    ];


    const allCookiesToPreserve = [
        ...new Set([...defaultAuthCookies, ...cookiesToPreserve])
    ];

    console.log(`App Version Check: Current app version = ${APP_VERSION}`);
    console.log(`Cookies to preserve:`, allCookiesToPreserve);


    const versionCookie = document.cookie
        .split("; ")
        .find((cookie) => cookie.startsWith("app_version="));

    const currentVersion = versionCookie ? versionCookie.split("=")[1] : null;

    console.log(`Current version from cookie: ${currentVersion || 'Not found'}`);


    const shouldClearCookies = currentVersion && currentVersion !== APP_VERSION;

    if (!shouldClearCookies) {

        if (!currentVersion) {
            console.log(`Setting initial version cookie: ${APP_VERSION}`);
            document.cookie = `app_version=${APP_VERSION}; path=/; max-age=31536000; SameSite=Lax${window.location.protocol === 'https:' ? '; Secure' : ''}`;
        } else {
            console.log(`Version matches (${currentVersion}). No action needed.`);
        }
        return false;
    }


    console.log(`Version mismatch: ${currentVersion} → ${APP_VERSION}. Performing controlled cleanup...`);


    const allCookies = document.cookie.split("; ");
    console.log(`Current cookies before cleanup:`, allCookies);

    let clearedCookiesCount = 0;


    allCookies.forEach(cookie => {
        const [name] = cookie.split("=");
        const trimmedName = name?.trim();

        if (trimmedName && trimmedName !== "app_version") {

            const shouldPreserve = allCookiesToPreserve.includes(trimmedName);

            if (!shouldPreserve) {

                const domainsToClear = [
                    window.location.hostname,
                    `.${window.location.hostname}`
                ];


                const pathsToClear = ['/', '/app', ''];

                domainsToClear.forEach(domain => {
                    pathsToClear.forEach(path => {
                        document.cookie = `${trimmedName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path || '/'}; domain=${domain};`;
                    });
                });

                clearedCookiesCount++;
                console.log(`Cleared cookie: ${trimmedName}`);
            } else {
                console.log(`Preserved cookie: ${trimmedName}`);
            }
        }
    });


    document.cookie = `app_version=${APP_VERSION}; path=/; max-age=31536000; SameSite=Lax${window.location.protocol === 'https:' ? '; Secure' : ''}`;


    if (localStorageToClear && localStorageToClear.length > 0) {
        localStorageToClear.forEach(key => {
            if (localStorage.getItem(key)) {
                localStorage.removeItem(key);
                console.log(`Cleared localStorage: ${key}`);
            }
        });
    }

    console.log(`Cleanup complete. Cleared ${clearedCookiesCount} cookies.`);


    if (shouldReload && currentVersion) {
        console.log(`Reloading page in 300ms for version update...`);
        setTimeout(() => {
            window.location.reload();
        }, 300);
        return true;
    }

    return true;
}